import { Typography } from 'omakase';
import { consumer } from '@tock/coretypes';
import Address from 'components/business/location/Address';
import BaseComponent from '@tock/shared/components/BaseComponent';

interface Props {
  business: consumer.IBusinessConfig;
  location: consumer.Location;
  isAtBusinessLocation: boolean;
}

class Location extends BaseComponent<Props> {
  render() {
    const { business, location, isAtBusinessLocation } = this.props;
    const { name, address, address2, city, state, zipCode } = location;

    if (!name && (!address || !state)) {
      return null;
    }

    const isBusinessAddressHidden = !business.shouldDisplayAddress;
    const showAddress = !isAtBusinessLocation || !isBusinessAddressHidden;

    return (
      <div className="Consumer-location">
        <div className="u-darkColor">
          <Typography component="span" variant="body02Strong">
            Location
            <span className="u-lightColor">
              {!isAtBusinessLocation && ` - Different from ${business.name}`}
              {isAtBusinessLocation &&
                isBusinessAddressHidden &&
                ' - Address is hidden, please contact the restaurant'}
            </span>
          </Typography>
        </div>
        {showAddress && (
          <Address
            locationName={isAtBusinessLocation ? undefined : name}
            address={address}
            address2={address2}
            city={city}
            state={state}
            zipCode={zipCode}
          />
        )}
      </div>
    );
  }
}

export default Location;
